import React, {useContext} from "react";
// react plugin used to create a form with multiple steps
import ReactWizard from "react-bootstrap-wizard";


// reactstrap components
import { Col } from "reactstrap";

// wizard steps
import Step1 from "./Step1.js";
import Step2 from "./Step2.js";
import Step3 from "./Step3.js";

var steps = [
  {
    stepName: "Pick an Event",
    stepIcon: "tim-icons icon-calendar-60",
    component: Step1,
  },
  {
    stepName: "Answer a few questions?",
    stepIcon: "tim-icons icon-notes",
    component: Step2,
  },
  {
    stepName: "Payment",
    stepIcon: "tim-icons icon-credit-card",
    component: Step3,
  },
];

const RegisterWizard = () => {

  const finishButtonClick = (allStates) => {

  };

  return (
    <>
      <div className="content">
        <Col className="mr-auto ml-auto" md="10">
          <ReactWizard
            steps={steps}
            navSteps
            validate
            title="Register for an Event"
            description="Register for an event at The Deep VBC"
            headerTextCenter
            finishButtonClasses="btn-wd btn-info"
            nextButtonClasses="btn-wd btn-info"
            previousButtonClasses="btn-wd"
            progressbar
            color="blue"
            finishButtonClick={finishButtonClick}
          />
        </Col>
      </div>
    </>
  );
};

export default RegisterWizard;
